import React from "react";
import axios from "axios";
import { useSiteContent } from "../hooks/useSiteContent";
import { STUDIO_GALLERY } from "../mock/mockData";

export default function GalleryPage() {
  const content = useSiteContent();
  const gallery =
    content?.gallery && content.gallery.length ? content.gallery : STUDIO_GALLERY;

  return (
    <div className="pb-16" data-testid="gallery-page">
      <header className="mb-8">
        <p className="text-[11px] uppercase tracking-[0.25em] text-neutral-500">
          Gallery
        </p>
        <h1 className="mt-1 text-2xl font-medium tracking-tight text-neutral-900 md:text-3xl">
          Our work at Lash Dollz Vk Beauty
        </h1>
        <p className="mt-3 max-w-xl text-sm text-neutral-600">
          A closer look at real lash sets, lip blush and award-winning artistry
          from the studio in Tralee, Co. Kerry.
        </p>
      </header>

      <div className="grid gap-4 sm:grid-cols-2 lg:grid-cols-3">
        {gallery.map((item, i) => (
          <figure
            key={item.id || i}
            data-testid={`gallery-photo-${i}`}
            className="group overflow-hidden rounded-3xl border border-neutral-200 bg-white"
          >
            <div className="overflow-hidden">
              <img
                src={item.imageUrl}
                alt={item.label || "Studio work"}
                className="h-72 w-full object-cover transition-transform duration-300 group-hover:scale-105"
              />
            </div>
            {(item.label || item.service) && (
              <figcaption className="px-4 py-3 text-xs text-neutral-600">
                {item.label && (
                  <p className="font-medium text-neutral-900">{item.label}</p>
                )}
                {item.service && (
                  <p className="mt-0.5 text-[11px] uppercase tracking-[0.23em] text-neutral-500">
                    {item.service}
                  </p>
                )}
              </figcaption>
            )}
          </figure>
        ))}
      </div>
    </div>
  );
}
